"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaymentReceiptsResponseDto = instanceOfPaymentReceiptsResponseDto;
exports.PaymentReceiptsResponseDtoFromJSON = PaymentReceiptsResponseDtoFromJSON;
exports.PaymentReceiptsResponseDtoFromJSONTyped = PaymentReceiptsResponseDtoFromJSONTyped;
exports.PaymentReceiptsResponseDtoToJSON = PaymentReceiptsResponseDtoToJSON;
exports.PaymentReceiptsResponseDtoToJSONTyped = PaymentReceiptsResponseDtoToJSONTyped;
var PaymentReceiptResponseDataDto_1 = require("./PaymentReceiptResponseDataDto");
/**
 * Check if a given object implements the PaymentReceiptsResponseDto interface.
 */
function instanceOfPaymentReceiptsResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function PaymentReceiptsResponseDtoFromJSON(json) {
    return PaymentReceiptsResponseDtoFromJSONTyped(json, false);
}
function PaymentReceiptsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(PaymentReceiptResponseDataDto_1.PaymentReceiptResponseDataDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function PaymentReceiptsResponseDtoToJSON(json) {
    return PaymentReceiptsResponseDtoToJSONTyped(json, false);
}
function PaymentReceiptsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(PaymentReceiptResponseDataDto_1.PaymentReceiptResponseDataDtoToJSON)),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
